import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const NAMES = ['María', 'Ana', 'Sofía', 'Valentina', 'Camila', 'Lucía', 'Martina', 'Julieta', 'Paula', 'Victoria'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'San Miguel de Tucumán', 'Salta', 'Santa Fe', 'San Juan'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [customer, setCustomer] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      triggerPopup();
    }, 4000);
    // Periodic interval
    const interval = setInterval(() => {
      triggerPopup();
    }, 12000 + Math.random() * 5000); // Random interval between 12-17s
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  const triggerPopup = () => {
    const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
    const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
    setCustomer({
      name: randomName,
      city: randomCity
    });
    setIsVisible(true);
    // Hide after 4 seconds
    setTimeout(() => {
      setIsVisible(false);
    }, 4000);
  };
  return <AnimatePresence data-id="element-1">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: 0
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 50
    }} transition={{
      duration: 0.5
    }} className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:bottom-4 z-50 max-w-sm w-full md:w-auto" data-id="element-2">
          <div className="bg-white rounded-lg shadow-xl p-4 flex items-center gap-4 border-l-4 border-green-500" data-id="element-3">
            <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-4">
              <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-5" />
            </div>
            <div data-id="element-6">
              <p className="text-sm font-medium text-gray-900" data-id="element-7">
                <span className="font-bold" data-id="element-8">{customer.name}</span> de{' '}
                {customer.city}
              </p>
              <p className="text-xs text-gray-600" data-id="element-9">
                acaba de comprar este libro digital
              </p>
              <p className="text-[10px] text-gray-400 mt-1" data-id="element-10">
                Hace unos instantes
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}